import apiStore from './index';
import { paths } from '@src/consts';
// import axios from 'axios';
import analytics from '@src/firebase/analytics';

import { KochavaSetup } from '..';



const requestDetails = async (payload = {},update, commonAnaytics) => {
  

  const { subscriberId, ...data } = payload ;

  try{
  const { data: body } = await apiStore.axios.put(
    paths.updateSubscriber + `/${subscriberId}`,
    data
  );

  if(body.error) throw body
  if(update) analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{SettingsUpdated: 'YES'}} )
  else analytics.logEvent( 'MERCHANDISE', { ...commonAnaytics, ...{AddressCollected: 'YES'}} )
  return body;
  }
  catch(error){
    if(update) analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{SettingsUpdated: 'NO', ErrorMessage: error.reason, ErrorCode:error.code} } )
    else analytics.logEvent( 'MERCHANDISE', { ...commonAnaytics, ...{AddressCollected: 'No',ErrorMessage: error.reason, ErrorCode:error.code} } )
    throw error;
  }
};

const orderMerchandise = async (payload = {} ,update, commonAnaytics) => {
  

  const { ...data } = payload ;
  // console.log('payload:', payload, update)

  var form_data = new FormData();


  const params = {
    ...data
  };

  
  for ( var key in params ) {
    form_data.append(key, params[key]);
  }

  try{
  const { data: body } = await apiStore.axios.post(
    paths.listMerchandise,
    form_data
  );

  if(body.error) throw body
  if(update) analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{SettingsUpdated: 'YES'}} )
  else analytics.logEvent( 'MERCHANDISE', { ...commonAnaytics, ...{AddressCollected: 'YES'}} )
  return body;
  }
  catch(error){
    if(update) analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{SettingsUpdated: 'NO', ErrorMessage: error.reason, ErrorCode:error.code} } )
    else analytics.logEvent( 'MERCHANDISE', { ...commonAnaytics, ...{AddressCollected: 'No',ErrorMessage: error.reason, ErrorCode:error.code} } )
    throw error;
  }
};

const updateOrederMerchandise = async (payload = {},update, commonAnaytics) => {
  const {  orderid, ...data } = payload;
  const params = {
    ...data
  };

 try{
  const { data: body } = await apiStore.axios.put(
    paths.listMerchandise + `/${orderid}`,
    params
  );
  
    if(body.error) throw body
    
  return body;
 }
 catch(error) {
  throw error;
 }
};


const requestPincode = async (payload = {}) => {
  
  const { subscriberId,zipCode, ...data } = payload ;
  const params = {"pincode":zipCode}
  try{
  const { data: body } = await apiStore.axios.get(
    paths.pincode,
    {params}
  );
  if(body.error) throw body
  return body;
  }
  catch(error){
    throw error;
  }
};

const fetchDetails = async (payload = {}) => {
  const { email } = payload;

  if (!email) return Promise.reject({ message: 'Email is required' });

  const params = { email };

  const { data: body } = await apiStore.axios.get(paths.getSubscriber, {
    params,
  });

  return Promise.resolve(body);
};

const requestPassword = async (payload = {}, commonAnaytics) => {
  const { subscriberId, oldpassword,password } = payload;

  const params = {
    oldpassword,
    password
  };

 try{
  const { data: body } = await apiStore.axios.put(
    paths.updateSubscriber + `/${subscriberId}`,
    params
  );
  
    if(body.error) throw body
    analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{PasswordUpdated: 'Yes'}} )

  return body;
 }
 catch(error) {
  analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{PasswordUpdated: 'No',ErrorMessage: error.reason, ErrorCode: error.code}} )
  throw error;
 }
};

const requestEmail = async (payload = {}, commonAnaytics) => {
  const { subscriberId, email } = payload;

  const params = {
    email,
  };
  try{
  const { data: body } = await apiStore.axios.put(
    paths.updateSubscriber + `/${subscriberId}`,
    params
  );


  if( body.error ) throw body ;
  analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'YES'}} )
  return body;
  }
  catch(error) {
    analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'NO',ErrorMessage: error.reason, ErrorCode: error.code} } )
    throw error;
  }
};

const requestdeleteSubscription = async (payload = {}, commonAnalytics) => {
 
  const { renewmode, paymentgateway } = payload;
  var form_data = new FormData();


  const params = {
    renewmode,
    paymentgateway
  };
  
  for ( var key in params ) {
    form_data.append(key, params[key]);
  }

  try{
  const { data: body } = await apiStore.axios.post(
    paths.testcancelplan,
    form_data
  );


  if( body.error ) throw body ;
  //analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'YES'}} )
//   const kochava = KochavaSetup();
//   kochava.sendEvent("REGISTER", {
//   ...commonAnalytics
// });
  return body;
  }
  catch(error) {
    //analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'NO',ErrorMessage: error.reason, ErrorCode: error.code} } )
    throw error;
  }
};

const requestDeleteAcocunt = async () => {
  // const { subscriberId, email } = payload;

  // const params = {
  //   email,
  // };
  try{
  const { data: body } = await apiStore.axios.delete(
    paths.getSubscriber
  );


  if( body.error ) throw body ;
  //analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'YES'}} )
  return body;
  }
  catch(error) {
   // analytics.logEvent( 'GENERALSETTINGS', { ...commonAnaytics, ...{EmailUpdated: 'NO',ErrorMessage: error.reason, ErrorCode: error.code} } )
    throw error;
  }
};

const fetchAvatars = async () => {
  const params = { castncrewtype: 'AVATAR' , paging: 'NO'};
  const { data: body } = await apiStore.axios.get(paths.fetchAvatars, {
    params,
  });

  return body;
};

const fetchMerchandise = async ({ itemtype }) => {
  const params = { itemtype };

  try{
  const { data: body } = await apiStore.axios.get(paths.listMerchandise, {
    params,
  });
  if( body.error ) throw body ;
  return body;
  }catch(error)
    {
      throw error;
    }
};


export {
  requestDetails,
  requestPincode,
  fetchDetails,
  requestPassword,
  fetchAvatars,
  fetchMerchandise,
  orderMerchandise,
  updateOrederMerchandise,
  requestEmail,
  requestDeleteAcocunt,
  requestdeleteSubscription
};
